import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DollarSign, Check } from 'lucide-react';
import { useCurrency } from '../../contexts/CurrencyContext';

const CurrencySettings = () => {
  const { t, i18n } = useTranslation();
  const { selectedCurrency, changeCurrency, currencies } = useCurrency();
  const [isExpanded, setIsExpanded] = useState(false);

  const handleCurrencyChange = (currencyCode) => {
    changeCurrency(currencyCode);
    setIsExpanded(false);
  };

  const currentCurrency = currencies[selectedCurrency];

  return (
    <div className="mb-6">
      <div className={`flex items-center mb-4 ${i18n.language === 'ar' ? 'flex-row-reverse space-x-reverse space-x-2 justify-start w-full' : 'space-x-2'}`}>
        <DollarSign className="h-5 w-5 text-muted-foreground" />
        <h3 className={`text-lg font-medium text-card-foreground ${i18n.language === 'ar' ? 'text-right' : 'text-left'}`}>
          {t('currency.title')}
        </h3>
      </div>
      
      <div className="space-y-3">
        {/* Combined Current Currency and Selection */}
        <div className="relative">
          <button
            onClick={() => setIsExpanded(!isExpanded)}
            className="w-full px-4 py-4 text-left bg-background border border-border rounded-lg hover:border-primary focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-colors duration-200"
          >
            <div className="flex items-center justify-between">
              <div className="flex items-center space-x-3">
                <span className="text-lg font-semibold text-primary">
                  {i18n.language === 'ar' ? currentCurrency.symbolAr : currentCurrency.symbol}
                </span>
                <div>
                  <p className="text-sm font-medium text-card-foreground">
                    {t('currency.current')}: {i18n.language === 'ar' ? currentCurrency.nameAr : currentCurrency.name}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {t('currency.select')} • {currentCurrency.code}
                  </p>
                </div>
              </div>
              <span className="text-sm text-muted-foreground">
                {isExpanded ? '▲' : '▼'}
              </span>
            </div>
          </button>

          {isExpanded && (
            <div className="absolute z-10 w-full mt-1 bg-card border border-border rounded-lg shadow-lg max-h-60 overflow-y-auto">
              {Object.entries(currencies).map(([code, currency]) => (
                <button
                  key={code}
                  onClick={() => handleCurrencyChange(code)}
                  className={`w-full px-4 py-3 text-left hover:bg-muted flex items-center justify-between ${
                    selectedCurrency === code ? 'bg-primary/10' : ''
                  }`}
                >
                  <div className="flex items-center space-x-3">
                    <span className="text-lg font-medium text-card-foreground">
                      {i18n.language === 'ar' ? currency.symbolAr : currency.symbol}
                    </span>
                    <div>
                      <p className="text-sm font-medium text-card-foreground">
                        {i18n.language === 'ar' ? currency.nameAr : currency.name}
                      </p>
                      <p className="text-xs text-muted-foreground">
                        {currency.code}
                      </p>
                    </div>
                  </div>
                  {selectedCurrency === code && (
                    <Check className="h-4 w-4 text-primary" />
                  )}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CurrencySettings;
